import ('./style.scss')

import ClusteredColumnChart from './clustered-column-chart'

export default ClusteredColumnChart